export default __webpack_public_path__ + "static/media/Checked.b582937f.svg";